import multiViewTemplate from 'emun.on-demand/templates/od-product-template-manager.multi-view.htm'
import listTemplate from 'emun.on-demand/templates/od-product-template-manager.list.htm'
import gridTemplate from 'emun.on-demand/templates/od-product-template-manager.grid.htm'
import headerTemplate from 'emun.on-demand/templates/od-product-template-manager.header.htm'
import actionsTemplate from 'emun.on-demand/templates/od-product-template-manager.actions.htm'
import resolve from 'ioc/resolve'
import ProductTemplateManagerDependentController from 'emun.on-demand/templates/od-product-template-manager-dependent.controller'

let ProductTemplateManagerDependentComponent = {
    bindings: {
        productTemplate: '<?',
        type: '@'
    },
    require: {
        manager: '^odProductTemplateManager'
    },
    controller: ProductTemplateManagerDependentController,
    templateUrl($element, $attrs) {
        if($attrs.templateUrl) return $attrs.templateUrl;
        else if($attrs.type === 'multi-view') return multiViewTemplate;
        else if($attrs.type === 'list') return listTemplate;
        else if($attrs.type === 'grid') return gridTemplate;
        else if($attrs.type === 'header') return headerTemplate;
        else return actionsTemplate;
    }
}

export default ProductTemplateManagerDependentComponent;
